import { Grid, Snackbar, TextField, Typography } from "@mui/material"
import React, { ReactElement, useEffect, useState } from "react"
import { Language, Translate } from "react-localize-redux"
import styled from "styled-components"
import Loader from "../../../components/Loader"
import { IPatient, ReduxStore } from "../../../constants/types"
import { Bill, BillItem, BillItemModes, DocumentType, CreatePaymentRequest } from "./types";
import { Alert } from "@mui/lab"
import { BillItems, Column } from "./BillItems"
import { useSnackBarState } from "../../../hooks"
import { useDispatch, useSelector } from "react-redux"
import { getBillablesAction } from "../../../redux/actions/investigationsActions"
import { resetBillItems, saveBillingItems } from "../../../redux/actions/billingActions"

interface Props {
    canUpdateBill: boolean,
    patient: IPatient,
    currency: string,
    uuidInvestigation?: string,
    idBillingInfo?:number,
    bill: Bill | null,
    print: boolean,
    isPaid: boolean,
    surveyAdditionalInfo?: any,
    withDiscount: boolean,
    onBillItemsValidated: (billItems: BillItem[]) => void,
    onUpdateBillItemStatus: (billItems: BillItem[], paymentRecord?: CreatePaymentRequest) => void,
    onCancelBill: () => void,
    onPaymentSuccess?: () => void
}

export const BillForm:React.FC<Props> = (props) => {
    const [loading, setLoading] = useState(false);
    const loadingBillables = useSelector((state:ReduxStore) => state.billing.loading);
    const billables = useSelector((state:ReduxStore) => state.billing.data.billablesCurrentBill ? state.billing.data.billablesCurrentBill : []);
    
    const [errorBill, setErrorBill] = useState<ReactElement | undefined>(undefined);
    
    const [showSnackbar, setShowSnackbar] = useSnackBarState();
    
    const dispatch = useDispatch();

    useEffect(() => {
        async function getBillables() {
            console.log(props.patient);
            const coverageId = props.patient?.personalData.coverage ? props.patient.personalData.coverage : null;
            await dispatch(getBillablesAction(props.uuidInvestigation, props.idBillingInfo, coverageId));
        }
        //Quiero actualizar los billables si cambia el seguro del paciente
        if (props.patient && props.idBillingInfo) {
            getBillables();
        }
    
    }, [props.patient?.uuid]);

    useEffect(() => {
        if(props.bill?.billItems){
            dispatch(saveBillingItems(props.bill.billItems));
        }
        else{
            dispatch(resetBillItems());
        }
    }, [props.bill]);
  

    async function onBillItemsValidated(items:BillItem[]){
        props.onBillItemsValidated(items);
    }

    async function onUpdateBillItemStatus(items:BillItem[], paymentRecord?: CreatePaymentRequest){
        props.onUpdateBillItemStatus(items, paymentRecord);
    }

    function renderItems(){
        if (loading || loadingBillables) {
            return (<Grid container >
                        <Grid item xs={12}>
                            <Loader />
                        </Grid>
                    </Grid>)
        }
        if(props.patient){
            let columns:Column[] = [{name:"concept", type:"autocomplete", validation:""}, {name:"type", type:"type", validation:""}, {name:"quantity", type:"number", validation:""}, {name:"unitCost", type:"amount", validation:""}, {name:"amount", type:"subtotal", validation:""}, {name:"updatedAt", type:"date", validation:""}];
            return(
                <>
                     <Snackbar
                        anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                        }}
                        open={showSnackbar.show}
                        autoHideDuration={2000}
                        onClose={() => setShowSnackbar({show:false})}>
                            <div>
                                {
                                    (showSnackbar.message && showSnackbar.severity) &&
                                    <Alert onClose={() => setShowSnackbar({show:false})} severity={showSnackbar.severity}>
                                        <Translate id={showSnackbar.message} />
                                    </Alert>
                                }
                        </div>
                    </Snackbar>
                    <BillItems key="bill_items" columns={columns} 
                        uuidPatient={props.patient?.uuid} mode = {BillItemModes.SHOW}
                        initItems = {props.bill ? props.bill.billItems :  []}
                        repeatBillItems={true} showTotal={true} 
                        //canUseAdditionalInfo={props.bill?.type === DocumentType.BUDGET}
                        canUseAdditionalInfo={false}
                        surveyAdditionalInfo={props.surveyAdditionalInfo} 
                        currency={props.currency} print={props.print} 
                        withDiscount={props.withDiscount}
                        bill={props.bill}  
                        canUpdateBill={props.canUpdateBill} uuidInvestigation={props.uuidInvestigation}
                        onBillItemsValidated={onBillItemsValidated} 
                        onUpdateBillItemStatus={onUpdateBillItemStatus}
                        error={errorBill}
                        isPaid={props.isPaid}
                        onCancelBill={props.onCancelBill}
                        onPaymentSuccess={props.onPaymentSuccess} />
                    </>
                ) 
        } 
    }          
    
    return (
        <Grid container >
            {
                renderItems()
            }
        </Grid>
    )
}